import { render } from "./not-found.vue?vue&type=template&id=0c1dec5c&ts=true"
import script from "./not-found.vue?vue&type=script&lang=ts"
export * from "./not-found.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__